<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 19.5002H21V12.7502L21.2194 12.9696C21.3604 13.1103 21.5515 13.1893 21.7507 13.1891C21.9499 13.189 22.1408 13.1097 22.2816 12.9687C22.4223 12.8277 22.5013 12.6366 22.5011 12.4374C22.5009 12.2382 22.4216 12.0472 22.2806 11.9065L13.0603 2.68899C12.779 2.4079 12.3977 2.25 12 2.25C11.6023 2.25 11.221 2.4079 10.9397 2.68899L1.71938 11.9065C1.57877 12.0472 1.49983 12.238 1.49991 12.437C1.5 12.6359 1.57911 12.8267 1.71984 12.9673C1.86057 13.1079 2.0514 13.1868 2.25033 13.1867C2.44927 13.1866 2.64002 13.1075 2.78062 12.9668L3 12.7502V19.5002H1.5C1.30109 19.5002 1.11032 19.5793 0.96967 19.7199C0.829018 19.8606 0.75 20.0513 0.75 20.2502C0.75 20.4492 0.829018 20.6399 0.96967 20.7806C1.11032 20.9212 1.30109 21.0002 1.5 21.0002H22.5C22.6989 21.0002 22.8897 20.9212 23.0303 20.7806C23.171 20.6399 23.25 20.4492 23.25 20.2502C23.25 20.0513 23.171 19.8606 23.0303 19.7199C22.8897 19.5793 22.6989 19.5002 22.5 19.5002ZM4.5 11.2502L12 3.75024L19.5 11.2502V19.5002H15V14.2502C15 14.0513 14.921 13.8606 14.7803 13.7199C14.6397 13.5793 14.4489 13.5002 14.25 13.5002H9.75C9.55109 13.5002 9.36032 13.5793 9.21967 13.7199C9.07902 13.8606 9 14.0513 9 14.2502V19.5002H4.5V11.2502ZM13.5 19.5002H10.5V15.0002H13.5V19.5002Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsHome'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>
